










import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import { IInstruction } from '@/requests/mainApi/models/IInstruction';

interface Data {}

interface Methods {

}

interface Computed {
  notificationBody: string | null;
}

interface Props {
  instruction: IInstruction | null;
}

export default Vue.extend({
  name: "Instruction",
  props: {
    instruction: {
      type: Object,
      default: () => {},
    },
  },
  methods: {

  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
